module.exports = __webpack_public_path__ + "static/media/twitter_icon.0c9462a7.svg";